import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ENSENANZAS } from '../../../graphql/actions/ensenanza';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import School from '@material-ui/icons/School';
import PeopleAlt from '@material-ui/icons/PeopleAlt';
import ThumbUpAlt from '@material-ui/icons/ThumbUpAlt';
// core components
import GridContainer from '../../../components/UI/Grid/GridContainer';
import GridItem from '../../../components/UI/Grid/GridItem';
import Card from '../../../components/UI/Card/Card';
import CardBody from '../../../components/UI/Card/CardBody';
import Button from '../../../components/UI/CustomButtons/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Notification from '../../../components/Notification/Notification';
// img
import img09 from '../../../assets/img/img09.jpg';

import sectionCursosStyle from '../../../assets/jss/coscef/views/indexSections/sectionCursosStyle';

const useStyles = makeStyles(sectionCursosStyle);

const IndexCursos = (props) => {
  const classes = useStyles();

  const {
    loading: loadingEnsenanzas,
    error: errorEnsenanzas,
    data: dataEnsenanzas,
  } = useQuery(GET_ENSENANZAS, {
    variables: {
      paginate: {
        numEnsenanzas: 3,
        cursor: '',
        sortBy: { field: 'createdAt', order: 'ASC' },
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  let showNotification = null;
  let seccionCardsEnsenanza = null;
  let seccionButton = null;

  if (loadingEnsenanzas) {
    seccionCardsEnsenanza = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorEnsenanzas) {
    seccionCardsEnsenanza = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title + ' ' + classes.textCenter}>
              Error al buscar las enseñanzas en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    showNotification = errorEnsenanzas.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEnsenanzas ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataEnsenanzas && dataEnsenanzas.getEnsenanzas) {
    const { getEnsenanzas } = dataEnsenanzas;
    //console.log(getEnsenanzas);
    if (getEnsenanzas.ensenanzas.length === 0) {
      seccionCardsEnsenanza = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title + ' ' + classes.textCenter}>
                No se encontraron enseñanzas, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );
    } else {
      seccionCardsEnsenanza = (
        <GridContainer>
          {getEnsenanzas.ensenanzas.map((ensenanza) => (
            <GridItem xs={12} sm={4} md={4} key={ensenanza.node._id}>
              <Card color='dark' key={ensenanza.node._id}>
                <CardBody color>
                  <h5
                    className={
                      classes.cardCategorySocialWhite + ' ' + classes.textCenter
                    }
                  >
                    {ensenanza.node.tipo === 'Cursos' ? (
                      <School />
                    ) : ensenanza.node.tipo === 'Talleres' ? (
                      <PeopleAlt />
                    ) : (
                      <ThumbUpAlt />
                    )}
                  </h5>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {ensenanza.node.tipo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {ensenanza.node.resumen + ' ...'}
                  </p>
                  <br />
                  <div
                    className={
                      classes.stats + ' ' + classes.justifyContentCenter
                    }
                  >
                    <Button
                      color='white'
                      round
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push('/enseñanzas');
                      }}
                    >
                      Saber más...
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionButton = (
        <GridContainer className={classes.marginTop10}>
          <GridItem
            md={4}
            sm={4}
            className={classNames(
              classes.mrAuto,
              classes.mlAuto,
              classes.textCenter
            )}
          >
            <Button
              type='submit'
              color='dark'
              round
              onClick={(e) => {
                e.preventDefault();
                props.history.push('/enseñanzas');
              }}
            >
              Leer más
            </Button>
          </GridItem>
        </GridContainer>
      );
    }
  }

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <div id='cursos'>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              className={classes.mlAuto + ' ' + classes.mrAuto}
            >
              <Card plain blog className={classes.card}>
                <GridContainer>
                  <GridItem xs={12} sm={4} md={4} className={classes.imgCenter}>
                    <img
                      src={img09}
                      alt='...'
                      className={
                        classes.imgRoundedCircle + ' ' + classes.imgFluid
                      }
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <br />
                    <br />
                    <h2 className={classes.title + ' ' + classes.textCenter}>
                      Cursos, talleres y entrenamientos.
                    </h2>
                    <h5
                      className={classes.description + ' ' + classes.textCenter}
                    >
                      Están diseñados y se cuenta con los medios tecnológicos
                      adecuados para realizar cursos, talleres interactivos y
                      entrenamientos temáticos.
                    </h5>
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.marginTop50}>
          {seccionCardsEnsenanza}
          {seccionButton}
        </div>
      </div>
      {showNotification}
    </div>
  );
};

export default withRouter(IndexCursos);
